module.exports = __webpack_public_path__ + "img/1Q.6f36f996.jpg";